//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MenuSub from "./menu-sub.vue";
import { setCookie } from "../../../../tools/cookie";
import designInterface from "../../../svg/designInterface.vue";
import designPrototype from "../../../svg/designPrototype.vue";
import designSystem from "../../../svg/designSystem.vue";
import teamwork from "../../../svg/teamwork.vue";
import community from "../../../svg/community.vue";
import communityActivity from "../../../svg/communityActivity.vue";
import communityPlugin from "../../../svg/communityPlugin.vue";
import download from "../../../svg/download.vue";
import recommend from "../../../svg/recommend.vue";
import introduce from "../../../svg/introduce.vue";
import HelpVideo from "../../../svg/help-video.vue";
import HelpBlog from "../../../svg/help-blog.vue";
import HelpContent from "../../../svg/help-center.vue";
import HelpJoinus from "../../../svg/help-joinus.vue";
import d2c from "../../../svg/d2c.vue";
export default {
  name: "MenuItem",
  components: {
    MenuSub,
    designInterface,
    designPrototype,
    designSystem,
    teamwork,
    community,
    communityActivity,
    communityPlugin,
    download,
    recommend,
    introduce,
    HelpVideo,
    HelpBlog,
    HelpContent,
    HelpJoinus,
    d2c,
  },
  inject: ["jumpCallBack", "sensors", "action"],
  props: {
    datas: {
      type: Object,
    },
    subState: {
      type: Boolean,
    },
    theme: {
      type: String,
      default: "light",
    },
  },
  data() {
    return {
      icon: "arrow-down",
    };
  },
  methods: {
    openSubHandle() {
      this.$emit("openSub", this.datas.id);
    },
    handle() {
      if (this.sensors) {
        const trackDatas = {
          action_parameter1: "header",
          action_type: "click",
          ...this.datas.eventId,
        };
        Object.assign(trackDatas, this.action);
        this.sensors.track("event_click", trackDatas);
      }
      const datas = JSON.parse(JSON.stringify(this.datas));
      datas.path = datas.path.replace("$origin$", location.origin);
      const { path } = datas;
      // item 点击跳转
      if (datas.code === "KaCase" && !datas.path.includes("http")) {
        // 确认是内部页面
        if (window.location.pathname === "/") {
          // 官网一级页面
          window.location.hash = "target-section-ka";
        } else {
          // 官网二级页面 + 社区
          setCookie("from", "master");
          window.location.href = window.location.origin + datas.path;
        }
      } else if (this.jumpCallBack) {
        this.jumpCallBack(datas, this.toPath);
      } else {
        this.toPath(path);
      }

      this.closeSubHandle();
    },
    toPath(path) {
      if (path && path.indexOf("http") === 0) {
        window.open(path, "_blank");
      } else if (path) {
        this.$router?.push(path);
      } else {
        const { path } = this.datas;
        this.$router?.push(path);
      }
    },
    closeSubHandle() {
      this.$emit("closeShowSub", this.datas.id);
    },
    className() {
      return [
        "menu-item",
        this.datas.background ? "menu-item-bgcolor" : "",
        this.datas.code,
      ];
    },
  },
};
